import React from "react";
import CardMobile from "./cardMobile";
import CardDesktop from "./cardDesktop";
import "./cardPais.sass";

export default function CardPais({ _id, gold, silver, bronze, total, organisation }) {
    return (
        <div key={_id}>
            <div className="line"></div>
            <div className="medallero-body">
                <div className="medallero-body-equipo">
                    <div className={`medallero-body-equipo-img`}>
                        <div className={`bandera-${_id}`}></div>
                    </div>
                    <p className="medallero-body-equipo-name">
                        {organisation}
                    </p>
                    <p className="medallero-body-equipo-name-short">
                        {/* {_id} */}
                    </p>
                </div>

                {/* menor a 780 */}
                <CardMobile gold={gold} silver={silver} bronze={bronze} total={total} />

                {/* mayor a 780 */}
                <CardDesktop gold={gold} silver={silver} bronze={bronze} total={total}/>
             
            </div>
        </div>
    )
}